import {Brick, registerBrick, Service} from 'olympe';
import {SHARED_MEMORY_TOPICS} from '../../../services/service_api/CreateAllRASharedMemory.brick';

/**
 * This brick fetch and process a system alias for a user from shared memory.
 */
export default class GetFromSystemAliasMap extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} userId
     * @param {function()} forwardEvent
     * @param {function(string)} setSystemAlias
     */
    update($, [userId], [forwardEvent, setSystemAlias]) {
        Service.get('allRaSharedMemory', {topic: SHARED_MEMORY_TOPICS.USER_SYSTEM_ALIAS, userId})
            .then((data) => {
                setSystemAlias(data.systemAlias);
                forwardEvent();
            });
    }
}

registerBrick('0197c5edbd6fe3d63a47', GetFromSystemAliasMap);
